import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { environment } from "@environment";
import { ConfigService } from "../config.service";
import { BehaviorSubject } from "rxjs";
import { ISystemPreferences } from "src/app/_interfaces/ISystemPreferences";
import { User } from "../../_models";

@Injectable({
  providedIn: "root",
})
export class SystemPreferencesService {
  private readonly baseUrl = this.environment.userApi.baseUrl;

  constructor(private http: HttpClient, private environment: ConfigService) {}

  getSystemPreferencesForUser(userId: number) {
    return this.http.get<ISystemPreferences>(
      `${this.baseUrl}/${userId}/systemPreferences`
    );
  }

  putSystemPreferencesForUser(
    userId: number,
    systemPreferences: ISystemPreferences
  ) {
    console.log(`${this.baseUrl}/${userId}/systemPreferences`)
    return this.http.put(
      `${this.baseUrl}/${userId}/systemPreferences`,
      systemPreferences
    );
  }
}
